<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page4">Copper Moon</a></h1><a id="page4">
<p class="book-auth">Rachel Caine</p>
<div class="img_container">
<img alt="image" src="images/logo.jpg"/>
</div>
</a><a id="page5">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?660d1f56